var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      {
        name: 'Navigation',
        to: {
          name: 'Navigation'
        }
      },
      {
        name: 'Edit',
        to: {
          name: 'NavigationEdit',
          query: {
            section: _vm.$route.query.section,
          },
        }
      }
    ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("編輯Navigation")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_c('span',[_vm._v("取消")])]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveHandler}},[_c('span',[_vm._v("儲存")])])],1),_c('div',{staticClass:"block",staticStyle:{"height":"70vh","margin-bottom":"30px"}},[_c('PageMenu',{attrs:{"sections":_vm.sections}},[_c(_vm.sectionView,{tag:"component",attrs:{"navigation":_vm.navigation}})],1)],1),_c('LangDialog',{attrs:{"isOpen":_vm.isLangOpen},on:{"update:isOpen":function($event){_vm.isLangOpen=$event},"update:is-open":function($event){_vm.isLangOpen=$event},"confirm-submit":_vm.saveHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }